export default "__VITE_ASSET__Drdlhqp8__"